import React from 'react';
import { StatusBar } from '../components/StatusBar';
import { BottomNav, TabId } from '../components/BottomNav';
interface AppLayoutProps {
  children: ReactNode;
  activeTab: TabId;
  onTabChange: (tab: TabId) => void;
}
export function AppLayout({
  children,
  activeTab,
  onTabChange
}: AppLayoutProps) {
  return <div className="flex flex-col h-screen bg-slate-900 text-white overflow-hidden" data-id="element-104">
      <StatusBar isOnline={false} isScannerConnected={true} lastSyncTime="10:42 AM" data-id="element-105" />

      <main className="flex-1 overflow-y-auto overflow-x-hidden relative" data-id="element-106">
        {children}
      </main>

      <BottomNav activeTab={activeTab} onTabChange={onTabChange} data-id="element-107" />
    </div>;
}